import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Grid,
  StepButton,
  StepLabel,
  Step,
  Stepper,
  useTheme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Circle from '@square-icons/react/24/Circle/circle';
import CircleCheck from '@square-icons/react/24/Circle/circle-check-fill';
import { pushHistoryWithSearchParams } from 'components/pages/checkout/utilities';

const useStyles = makeStyles((theme) => ({
  root: {
    overflowX: 'auto',
    borderBottom: `1px solid ${theme.color.border}`,
  },
  label: {
    color: theme.color.gray['30'],
    '&$completed': { color: theme.color.blue },
  },
  completed: {},
}));

const icon = (props) => {
  const theme = useTheme();

  const { active, completed } = props;

  return completed ? (
    <CircleCheck style={{ fill: theme.color.blue }} />
  ) : (
    <Circle style={{ fill: active ? 'inherit' : 'rgb(0,0,0,0.26)' }} />
  );
};

const StatusBar = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const {
    stepConfig: { steps, labelRedirect },
  } = props;

  // find the index of the current route - this needs to be passed into Stepper below
  // so it knows which step to mark as active - if the current route is not found we
  // return -1 which means the user has reached the /complete step. Stepper disables
  // all steps when it receives -1, which is the behavior we want.
  const activeStep = Object.values(steps).findIndex((step) =>
    step.includes(location.pathname),
  );

  const stepComponents = () =>
    Object.keys(steps).map((label) => (
      <Step key={label}>
        <StepButton
          component="div"
          disableTouchRipple
          onClick={() => {
            if (labelRedirect[label]) {
              window.location.href = labelRedirect[label];
            } else {
              pushHistoryWithSearchParams(history, steps[label][0]);
            }
          }}
        >
          <StepLabel
            classes={{ label: classes.label, completed: classes.completed }}
            StepIconComponent={icon}
            StepIconProps={activeStep < 0 ? { completed: true } : {}}
          >
            <p className="medium-30">{t(`checkout.nav.${label}`)}</p>
          </StepLabel>
        </StepButton>
      </Step>
    ));

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={9} className={classes.root}>
        <Grid container>
          {/* see below for why we do auto margin on item instead of justify center on the container */}
          <Grid item xs={8} style={{ minWidth: 600, margin: 'auto' }}>
            <Stepper activeStep={activeStep} sx={{ p: 3 }}>
              {stepComponents()}
            </Stepper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

// https://stackoverflow.com/questions/33454533/cant-scroll-to-top-of-flex-item-that-is-overflowing-container

export default StatusBar;
